import * as React from "react";
import { Box, Stack, Typography } from "@mui/material";
// project import
const Toolbar = ({ title, children }) => {
    return (
        <Box>
            <Stack
                direction={{ xs: "column", sm: "row" }}
                alignItems={{ xs: "stretch", sm: "right" }}
                justifyContent={"space-between"}
                spacing={2}
            >
                <Box>
                    <Typography variant={"h3"}>{title}</Typography>
                </Box>
                <Box>
                    <Stack
                        direction={"row"}
                        alignItems={{ xs: "stretch", sm: "right" }}
                        justifyContent={"flex-end"}
                        spacing={4}
                    >
                        {children}
                    </Stack>
                </Box>
            </Stack>
        </Box>
    );
};
export default Toolbar;
